import React from "react";
import APPCONFIG from "constants/Config";
import Framework from "@beardeddevops/react.framework";
import {Collections, Objects} from "components";
import {Button} from "reactstrap";

const {UniversalModal} = Framework.Elements;

const breadcrumbsStatic = [
	{
		name: "Dashboard",
		url: "/dashboard",
		icon: "dashboard",
	},
	{
		name: "Services",
		url: "/services",
		icon: "wrench",
	},
];

export default class Services extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbsStatic} history={this.props.history}>
					<Button
						data-id="add-service"
						onClick={this.toggle("modalService")}
						size="sm"
						className="primary-button"
					>
						<i className="fa fa-plus" />
						&nbsp;&nbsp;Add Service
					</Button>
				</Framework.Components.PageBar>

				<Framework.Errors.General isDev={APPCONFIG.settings.isDev()}>
					<Collections.Services
						history={this.props.history}
						reloadShell={this.props.reloadShell}
						reloadPage={this.refreshPage}
						reloadSelf={this.state.refresh}
					/>
				</Framework.Errors.General>

				<UniversalModal
					isDev={APPCONFIG.settings.isDev()}
					locations={this.props.locations}
					name={"Service"}
					object={Objects.Service}
					history={this.props.history}
					toggle={this.state.modalService}
					reportClose={this.reportClose("modalService")}
					afterSave={this.handleAfterSave}
					size="lg"
					project={'pos'}
				/>
			</div>
		);
	}
}
